import React, { Component } from "react";
import { Storage } from "aws-amplify";
import { Mutation } from "react-apollo";
import { Button, Modal } from "antd";
import DeleteCertificate from "../../GraphQL/Mutation/DeleteCertificate";

const confirm = Modal.confirm;

class ButtonAction extends Component {
  onDownload() {
    const { key, bucket, region } = this.props.file;
    Storage.get(key, {
      level: "private",
      bucket: bucket,
      region: region
    }).then(result => {
      window.open(result, "_blank");
    });
  }

  showDeleteConfirm(mutate) {
    confirm({
      title: "¿Estás seguro de eliminar este certificado?",
      okText: "Sí, eliminar",
      okType: "danger",
      cancelText: "No, conservar",
      onOk: () => this.onRemove(mutate)
    });
  }

  onRemove(mutate) {
    const { serial, cerFile, keyFile } = this.props;
    mutate({
      variables: { serial }
    })
      .then(data => {
        this.props.refetch();
        Storage.remove(cerFile.key, {
          level: "private",
          bucket: cerFile.bucket,
          region: cerFile.region
        });
        Storage.remove(keyFile.key, {
          level: "private",
          bucket: keyFile.bucket,
          region: keyFile.region
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  handleAction(mutate) {
    const { type } = this.props;
    if (type === "download") {
      this.onDownload();
    } else {
      this.showDeleteConfirm(mutate);
    }
  }

  render() {
    const { type, label } = this.props;
    return (
      <Mutation mutation={DeleteCertificate}>
        {mutate => (
          <Button
            icon={type}
            size="small"
            style={{ border: 0, backgroundColor: "transparent" }}
            onClick={() => this.handleAction(mutate)}
          >
            {label}
          </Button>
        )}
      </Mutation>
    );
  }
}

export default ButtonAction;



// WEBPACK FOOTER //
// ./src/Components/Profile/ButtonAction.js